import {Component, EventEmitter, inject, Output} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {ToastrService} from "ngx-toastr";


@Component({
	selector: 'isf-bills-pastein',
	standalone: true,
	imports: [
		FormsModule
	],
	template: `

        <div>
            <textarea id="isfBills" [(ngModel)]="txtIn" cols="30" rows="5" placeholder="Paste bill numbers here"
                      class="form-control form-control-plaintext bg-body-secondary"></textarea>
            <div>
				<div class="row">
					<div class="col-6">
                        <button class="btn btn-lg btn-secondary w-100" (click)="submit()">
                            <i class="bi bi-check-circle-fill text-success"></i> OK
						</button>
					</div>
					<div class="col-6">
                        <button class="btn btn-lg btn-secondary w-100" (click)="clear()">
                            <i class="bi bi-x-circle-fill text-danger"></i> Clear
						</button>
					</div>
				</div>
            </div>
        </div>
	`,
	styles:[`
	
	`]
})
export class IsfBillsPasteInForm{

	txtIn!:string;
	
	@Output()
	onSubmit:EventEmitter<string[]> = new EventEmitter();
	
	@Output()
	onClear:EventEmitter<void> = new EventEmitter();
	
	toastr:ToastrService = inject(ToastrService);
	
	
	submit(){
	
		if(this.txtIn == null || this.txtIn == ""){
			
			this.toastr.error("Bill of Lading(s) is required","Not Good",{
				positionClass: 'toast-top-center',
				progressBar:true,
				closeButton:true,
			});
			
			return;
		}
		
		let bills:Array<string> = this.txtIn.split("\n")
			.filter(t => t != "" && t != null)
			.map((bill) => bill.trim().toUpperCase().replace(/\W/g, ''));
		
		
		this.onSubmit.emit(Array.from(new Set(bills)));
	}
	
	
	clear(){
		this.txtIn = "";
		this.onClear.emit();
	}
}
